export const environment = {
    production: false,
    urlBack: 'https://palbox.api.atalaya.ai/api/v1/',
    urlFront: 'https://palbox.app.atalaya.ai/login',
    client_id: 'nUA84La9N2X3cUNztKQgderwZohggPoGKVVVBwLj',
    client_secret:
        'lbzE7502CPj4S9RlBSrso7IqL14q6jXEE0Ii1UFmBnffjD82FmGWCOHyWb47LsHIFJnDCUvz5482dPjA6OaZYeHC5Rx8aaNKndMrwk85I17m9tE2u3E3EZMe6rCHr3hA',
};
